<template>
    <section class="title-section">
        <video-player
            video-id="779493688"
            :controls="false"
            :autoplay="true"
            class="main-video"
            type="main_video"
        ></video-player>
        <div class="title">
            <h1>검은산: <br />2022년 <br />울진 산불</h1>
            <div class="newstapa-logo">
                <svg viewBox="0 0 183.36 65.88">
                    <path
                        d="M130.9,13.35c.4,.72,.75,1.48,1.23,2.14,1.13,1.56,1.8,3.13,.69,5.01-.23,.4-.18,.96-.26,1.44-.36,2.18-.72,4.36-1.07,6.48,.74-.33,1.97-.93,3.25-1.42,2.15-.83,4.29-2.08,6.49-2.22,2.47-.16,3.21-1.21,3.75-3.28,.97-3.67,2.36-7.24,3.23-10.93,.74-3.13,2.77-4.71,5.57-5.77,1.56,.92,2.74,1.8,1.72,4.07-.61,1.37-.3,3.14-.42,4.73-.14,2.01-.17,4.04-.47,6.02-.34,2.23,.84,2.92,2.66,2.7,2.87-.36,5.74-.85,8.55-1.53,4.95-1.2,9.91-.92,14.84-.17,.93,.14,1.66,1.56,2.7,2.62-1.24,.66-1.86,.99-2.49,1.32-.05,.15-.18,.33-.15,.46,.83,2.84,.28,3.2-2.55,3.74-7.7,1.45-15.37,3.08-22.98,4.93-2.35,.57-3.33,2.98-3.45,5.25-.17,3.3,.12,6.61,.09,9.92-.01,1.18-.04,2.61-.67,3.48-.62,.86-2.01,1.53-3.09,1.57-.65,.03-1.65-1.18-1.98-2.03-2.29-5.84-3.53-11.87-2.83-18.19,.12-1.05-.09-2.14-.17-3.83-3.62,1.98-7.14,3.57-10.29,5.7-3.9,2.64-7.49,5.73-11.23,8.62-2.28,1.76-5.69,2.01-8.04,.41-.38-.26-.49-1.7-.16-2.05,1.72-1.77,3.44-3.7,5.53-4.94,2.61-1.55,4.34-3.12,4.96-6.39,.77-4.08,2.51-7.98,3.93-11.92,.69-1.91,1.61-3.73,2.43-5.59,.23-.11,.45-.22,.68-.33Zm46.16,11.9c-.28,.72-.53,1.37-.9,2.31h3.61c-.12-.87-.22-1.56-.32-2.31h-2.38Z"
                    />
                    <path
                        d="M18.24,40.12c-1.52,1.12-3.02,2.28-4.56,3.37-3.76,2.65-8.22,2.25-12.46,2.72-1.28,.14-1.69-2.69-.56-4.22,2.31-3.15,5.21-5.43,9.07-6.55,4.47-1.3,9.32-2.15,13.13-4.55,3.31-2.09,6.67-1.78,9.93-2.75,2.06-.61,3.69-1.37,5.87-.45,3.03,1.29,3.86,3.99,1.65,6.42-.29,.32-.82,.66-1.22,.64-5.78-.29-8.98,3.5-11.89,7.57-3.4,4.76-6.6,9.66-9.9,14.49-.18,.26-.46,.44-1.07,.99v-4.44c-1.32,1.79-2.17,4.05-4.19,1.49-.51,1.13-.94,2.09-1.47,3.26-1.58-7.97,4.17-12.43,7.66-17.98Z"
                    />
                    <path
                        d="M12.82,15.78c-.03,.5-.02,1-.1,1.49-.38,2.29,.92,2.61,2.67,2.14,2.08-.55,4.1-1.28,6.16-1.89,.63-.19,1.29-.28,1.94-.34,4.08-.34,6.28,1.7,5.84,5.66-.08,.68-1.19,1.5-1.99,1.81-2.86,1.1-5.85,1.85-8.68,3.03-2.18,.91-4.09,2.42-6.27,3.34-1.4,.59-3.08,.9-4.58,.77-2-.17-3.67-.8-3.74-3.59-.1-4.16-1.14-8.3-1.16-12.46-.02-3.91,0-7.99,2.03-11.55,.63-1.1,1.76-2.39,2.88-2.64,1.81-.41,2.88,1.22,3.23,2.79,.83,3.76,1.42,7.57,2.1,11.37-.12,.02-.23,.04-.35,.06Z"
                    />
                    <path
                        d="M102.75,64.87c-3.73-.25-4.91-1.49-5.88-5.4-1.51-6.07-2.49-12.23-1.19-18.4,1.19-5.6,2.73-11.17,4.69-16.56,.69-1.9,3.06-3.19,4.97-5.06,2.84,5.2,.11,9.22-1.39,13.87,4.39-1.15,8.26-2.23,12.17-3.15,1-.24,2.13,.05,3.2,.09-.01,.26-.03,.51-.04,.77-.86,.05-1.72,.11-2.94,.18,1.32,.77,2.34,1.37,3.28,1.92-3.65,4.8-9.77,5.38-14.55,8.3-2.01,1.23-3.6,2.46-3.51,4.88,.1,3.01-.23,6.3,.9,8.94,1.44,3.38,.07,6.32,.31,9.61Z"
                    />
                    <path
                        d="M62.22,18.32c.87,.36,1.75,.72,3.29,1.36-1.54,.48-2.47,.77-3.4,1.05,.15,.13,.3,.26,.45,.39-.32,.36-.63,1.01-.96,1.02-1.81,.06-3.65,.14-5.43-.12-3.33-.5-4.36,.28-5.79,3.4-.63,1.36-2.41,2.19-3.7,3.24-.33,.27-.75,.51-1.16,.61-.62,.15-1.41,.44-1.86,.19-.56-.32-1.1-1.07-1.22-1.72-1.27-7.24,1.14-13.93,3.8-20.37,1.17-2.84,2.74-6.25,6.32-7.33,.69-.21,2.29,.43,2.43,.95,.43,1.58,.73,3.38,.39,4.95-.79,3.68-.9,3.82,2.27,5.82,.98,.61,1.98,1.19,2.99,1.76,2.12,1.19,2.6,2.6,1.58,4.81Z"
                    />
                    <path
                        d="M130.9,13.35c-.23,.11-.45,.22-.68,.33-2.2-.01-4.4-.07-6.59-.02-1.35,.03-2.03,.65-2.04,2.18,0,3.04-.22,6.09-.39,9.13-.08,1.56-.76,3.15-2.46,2.61-1.23-.39-2.74-1.87-2.94-3.06-.45-2.65-.26-5.42-.14-8.14,.08-1.73-.24-2.73-2.24-2.59-1.57,.1-3.15,.01-4.72,.02-1.56,0-3.45-.16-3.42-1.98,.02-1.33,1.03-3.07,2.14-3.86,1.41-.99,3.35-1.58,5.11-1.69,8.11-.5,16.23-.79,24.34-1.13,2.07-.09,3.52,.39,3.4,3.02-.05,1.17,.74,2.38,1.26,3.92-3.8,.45-7.21,.86-10.63,1.26Z"
                    />
                    <path
                        d="M74.41,32.35c6.43-4.46,12.75-6.7,19.97-6.81-.35,.64-.72,1.3-1.1,1.99,.83,.37,1.56,.7,2.05,.91-.26,.87-.37,1.59-.68,2.22-.44,.88-.84,2-1.59,2.47-1.94,1.2-4.04,2.2-6.15,3.1-2.14,.91-3.46,2.41-4.22,5.12,4.13-.96,7.97-1.85,12.18-2.82-1.47,3.55-3.56,6.89-6.48,7.63-3.4,.87-6.03,3.17-9.41,3.78-2.72,.48-5.15-1.48-4.72-4.17,.36-2.27,.77-4.62,1.68-6.71,1.06-2.47,2.35-4.67-1.52-6.72Z"
                    />
                    <path
                        d="M71.96,28.7c-5.18,2.73-10.61,5.09-15.46,8.31-3.76,2.49-8.05,3.14-12.01,4.82-.79,.33-2.18-.08-2.95-.63-.42-.3-.46-1.9-.05-2.42,1.61-2.01,3.13-4.52,5.3-5.58,5.31-2.6,10.92-4.61,16.51-6.58,1.39-.49,3.17,0,4.74,.23,1.32,.2,2.6,.69,3.9,1.05,0,.26,.01,.53,.02,.79Z"
                    />
                    <path
                        d="M97.26,14.76c1.35-.21,1.95-.31,2.93-.47-.35,.73-.47,1.48-.89,1.76-2.91,1.92-5.82,3.86-8.87,5.57-1.78,.99-3.89,1.39-5.68,2.36-2.18,1.17-4.1,.62-6.14-.21-1.14-.46-2.39-.65-3.52-1.12-.69-.29-1.66-.81-1.76-1.36-.11-.59,.48-1.72,1.05-1.97,6.75-2.93,13.53-5.82,20.4-8.45,.7-.27,2.05,1.18,3.11,1.81,.37,.22,.76,.39,1.25,.63-.41,.32-.84,.65-1.87,1.45Z"
                    />
                    <path
                        d="M30.61,65.24c-.47-.31-.99-.94-1.41-.88-2.12,.31-2.88-1.02-2.76-2.6,.32-4.16,.9-8.31,1.43-12.45,.06-.46,.35-.94,.65-1.32,1.85-2.37,3.74-4.72,5.63-7.11,2.25,4.72,4.02,7.06,.88,11.5-2.08,2.94-2.66,6.52-2.54,10.15,.04,1.12-.1,2.24-.48,3.37l-.82-2.42c-.12,0-.25-.01-.37-.02-.08,.62-.16,1.24-.23,1.79Z"
                    />
                </svg>
            </div>
        </div>
        <!-- <img
            :src="require('../assets/imgs/blackmountain_w-r.png')"
            alt=""
        /> -->
    </section>
</template>

<script>
import $ from 'jquery';
export default {
    data() {
        return {
            windowAspectRatio: 1,
            stdRatio: 1.777,
        };
    },
    name: 'TitleSection',
    methods: {
        changeVideoRatio() {
            if (this.windowAspectRatio > this.stdRatio) {
                $('video').css({
                    width: `100%`,
                    height: `auto`,
                });
            } else {
                $('video').css({
                    width: `auto`,
                    height: `100%`,
                });
            }
        },
        getNext() {
            if ($('body').height() - 50 <= window.innerHeight + window.pageYOffset) {
                this.$router.push({ path: 'chapter1' });
            }
        },
    },
    mounted() {
        this.windowAspectRatio = window.innerWidth / window.innerHeight;
        window.addEventListener('resize', () => {
            this.windowAspectRatio = window.innerWidth / window.innerHeight;
        });
        addEventListener('scroll', this.getNext);
    },
    unmounted() {
        removeEventListener('scroll', this.getNext);
    },
    watch: {
        windowAspectRatio: 'changeVideoRatio',
    },
};
</script>
<style lang="scss" scoped>
.title-section {
    font-weight: 400;
    font-size: 35px;
    height: auto;
    text-align: center;
    // padding: 20px;
    position: relative;
    background-position: center;
    background-size: contain;
    height: 100vh;
    align-content: center;
    overflow: hidden;
    .title {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        padding: 15px;
        z-index: 4;
        backdrop-filter: blur(20px);
        box-shadow: 0 0 40px 10px rgba(0, 0, 0, 0.5);
        h1 {
            font-family: miller-display, sans-serif;
            font-style: normal;
            text-align: left;
            color: $white;
            margin-bottom: 50px;
            line-height: 1.1;
            text-align: center;
        }
    }

    .newstapa-logo {
        width: 70px;
        margin: 0 auto;
        display: flex;
        svg {
            width: 100%;
            height: 100%;
            path {
                fill: $white;
            }
        }
    }

    video {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }

    #lettering {
        position: absolute;
        width: 100%;
        max-width: 200px;
        top: 49%;
        left: 50%;
        z-index: 0;
        transform: translate(-50%, -50%);
        display: none;
        path {
            fill: black;
        }
    }
}

@media all and (max-width: 800px) {
    .title-section {
        .title {
            top: 50%;
            bottom: auto;
            transform: translate(-50%, -50%);
        }
        height: 100vh;
    }
}

@supports (-webkit-touch-callout: none) {
    .title-section {
        height: -webkit-fill-available;
    }
}
</style>
